import React from 'react';
import { IDetailField } from '../../../../stores/service-finance.store';
import * as styles from './review-page.less';

interface IDetailProps {
    header: string;
    details: IDetailField[][];
}

export const ReviewItem: React.FC<IDetailProps> = ({ header, details }) => {
    return (
        <>
            <div className={styles.subTitle}>
                <span>{header}</span>
            </div>
            <table className={styles.table}>
                <tbody>
                    {details.map((row, index) => (
                        <tr key={index}>
                            {row.map((detail, innerIndex) => (
                                <td className={styles.cell} key={innerIndex}>
                                    <div>{detail.title}</div>
                                    <div>{detail.value}</div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};
